import { instance as axios, setJwtToken } from "../../config/axiosInstance";

export const getCronJobsApi = async () => {
  return await axios.get("/admin/cron-jobs/list", setJwtToken());
};

export const toggleCronJobApi = async (name, enabled) => {
  return await axios.post("/admin/cron-jobs/toggle", { name, enabled }, setJwtToken());
};
